import qs from 'qs'
import { Configuration } from '@reapit-sales/api-v2'

export type ZohoRequestType = 'SubmitSupportRequest' | 'SystemChangeRequest'

type ZohoConfigType = {
  [key in ZohoRequestType]: {
    url: string
  }
}

const ZohoConfig: ZohoConfigType = {
  SubmitSupportRequest: {
    url: 'https://creatorapp.zohopublic.com/hayley.rees/service/form-embed/Support_Request/wn53mUS6HH1j1sug5gmTRSVXvqYp8xPWTSYHX5stdqJZGZ2DGTmTajEFeKf2Qm0jpCDSMNX3COQCNOESpQ55OAO7QQffGeumB4ky',
  },
  SystemChangeRequest: {
    url: 'https://creatorapp.zohopublic.com/hayley.rees/service/form-embed/Request/kbwk0WySERz09mA0YmAhfUW1jUktBFpEpAhgv8gbU9HWgQDVssVBepD83FPwGJZP7Rzaz3u28BJshrMr6uW8HavjDMjhUXxhr4hS',
  },
}

export const ZOHO_MODAL_TITLE: Record<ZohoRequestType, string> = {
  SubmitSupportRequest: 'Support Request',
  SystemChangeRequest: 'System Change Request',
}

export const generateZohoURL = (type: ZohoRequestType, userConfig: Configuration): string => {
  if (!userConfig.staffMember) {
    throw new Error('Staff member data is not available')
  }

  const config = ZohoConfig[type]
  const params = {
    UserEmail: userConfig.staffMember.email,
    UserFirstName: userConfig.staffMember.firstName,
    UserLastName: userConfig.staffMember.lastName,
    UserOfficeName: userConfig.staffMember.officeName,
    UserAccessLevel: userConfig.accessLevel.id,
    UserID: userConfig.staffMember.memId,
    UserOfficeAbmsID: userConfig.settings.system?.abmsId || '',
    Contact_Name: userConfig.staffMember.firstName + ' ' + userConfig.staffMember.lastName,
    Contact_Email: userConfig.staffMember.email,
    Contact_Phone: userConfig.staffMember.mobile ? userConfig.staffMember.mobile : userConfig.staffMember?.phone || '',
    Company_Name: userConfig.staffMember.officeName,
    ...(type === 'SubmitSupportRequest' && { Request_Type: 'Help' }),
  }

  const queryString = qs.stringify(params, { encode: true })
  return `${config.url}?${queryString}`
}
